<template>
  <div>
      <div>
        <a href="javascript:void(0)" class="abroad-share-icon weixin" @mouseenter="renderQrcode">
            <img src="//statics.itc.cn/mptc-mpfe/img/article/icon_Wechat.png" alt="" class="abroad-share-img">
            <div class="abroad-wx-code">
                <div class="code-pic">
                    <div id="qrcode" class="qrcode"></div>
                </div>
            </div>
        </a>
        <a :href="sina_url" target="_blank" class="abroad-share-icon"><img src="//statics.itc.cn/mptc-mpfe/img/article/icon_Weibo.png" alt="" class="abroad-share-img"></a>
        <a :href="qzone_url" target="_blank" class="abroad-share-icon"><img src="//statics.itc.cn/mptc-mpfe/img/article/icon_Space.png" alt="" class="abroad-share-img"></a>
        <a 
            href="javascript:void(0)" 
            class="abroad-share-icon copy-link" 
            @click="handleCopyLink" 
            :data-clipboard-text="copyLink" 
            id="copyLink"
        >
            <img src="//statics.itc.cn/mptc-mpfe/img/article/icon_Link.png" alt="" class="abroad-share-img">
        </a>
    </div>
    <div class="toast" ref="shareToastRef">
        <div class="toast-text">链接复制成功</div>
    </div>
  </div>
</template>
<script>
import { acodeConfig } from '@/config/spmConfig'
import Utils from "@/utils/Utils"
import QRCode from 'qrcodejs2'
import Clipboard from 'clipboard'

export default {
  name: "",
  data() {
    return {
        qrcodeUrl: '/a/' + window.pcArticleInfo?.news_id + '_' + window.pcArticleInfo?.media_id,
        sina_url: '',
        qzone_url: '',
        mobile_host: Utils.getWapSohuHost(),
        acode: acodeConfig.shareAction,
        rendered: false,
        copyLink: '',
        param: {
            url: window.location?.href,
            pic: '',
            content: '',
        },
	}
  },
  mounted() {
      this.init()
  },
  methods: {
        init() {
            let pic_el = document.querySelector('article img')
            let srcUrl = pic_el?.getAttribute('src')
            this.param.pic = srcUrl ? srcUrl : ""
            this.copyLink = document.title + " - 搜狐网" + "\n" + this.mobile_host + this.qrcodeUrl + '?_trans_=010004_pcwzy';
            this.sina_url = "http://service.weibo.com/share/share.php?url=" + encodeURIComponent(this.param.url) + "&title=" + encodeURIComponent(document.title) + "&searchPic=true&pic=" + this.param.pic+"&appkey=2890110694";
            this.qzone_url = "http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=" + encodeURIComponent(this.param.url);
        },
        handleCopyLink() {
            var clipBoard = new Clipboard('#copyLink')
            clipBoard.on('success', () => {
                clipBoard.destroy() // 销毁上一次的复制内容
                clipBoard = new Clipboard('#copyLink')
                this.$refs['shareToastRef'].style.display = 'block'
                setTimeout(()=>{
                    this.$refs['shareToastRef'].style.display = 'none'
                },1000)
            })
            clipBoard.on('error', function(err) {
                console.log('复制失败',err)
            })
        },
        renderQrcode() {
            window.sohuSpm?.sendAction({
                acode: 3032,
                clkParam: 'shareCode:wxf'
            });
            if(this.rendered){
                return;
            }
            new QRCode(document.querySelector('.qrcode'), {
                text: this.mobile_host + this.qrcodeUrl, // 需要转换为二维码的内容
                width: 84,
                height: 84,
                colorDark: '#000000',
                colorLight: '#ffffff',
                correctLevel: QRCode.CorrectLevel.H
            })
            this.rendered = true;
        },
    }
};
</script>
<style lang="less" scoped>
.weixin {
    .abroad-wx-code {
            display: none;
            position: absolute;
            top: 30px;
            left: -50px;
            width: 120px;
            height: 120px;
            background: url('../images/share-box.png') no-repeat;
            background-size: 100% 100%;
            .code-pic { 
                height: 120px; 
                display: flex;
                align-items: center;
                justify-content: center;
            }
    }
}
.weixin:hover .abroad-wx-code{
    display:block;
}
</style>
